export default __webpack_public_path__ + "static/featured-image-a3f5c6c2a77a41eefe3616c0e43d5ee7.jpg";